<div class="banner-card" [id]="id" [class]="class" (dblclick)="navigate()" [style]="css">
    <!-- <div (click)="navigate()" class="banner-card-title">{{title}}</div> -->
    <div (click)="navigate()" class="banner-card-img" *ngIf="image"><img loading="lazy" [src]="image" [alt]="title"></div>
    <div (click)="navigate()" class="banner-contents">
        <ng-content></ng-content>
    </div>
    <div class="banner-contents" *ngIf="customBody">
        <ng-content select="[body]"></ng-content>
    </div>

    <!-- <div class="banner-card-description" [innerHTML]="description|safe:'html'"></div> -->
    <div class="banner-card-action" *ngIf="actionText.length>0">
        <a *ngIf="link && !url" [routerLink]="link">{{actionText}} &gt;
            <!-- <fa-icon [icon]="faArrowRight"></fa-icon> -->
        </a>
        <a *ngIf="url" [href]="url">{{actionText}} &gt;
            <!-- <fa-icon [icon]="faArrowRight"></fa-icon> -->
        </a>
        <span *ngIf="!url && !link">{{actionText}} &gt;
            <!-- <fa-icon [icon]="faArrowRight"></fa-icon> -->
        </span>

    </div>
    <ng-content select="[absolute]"></ng-content>
</div>